import { adminAreaQueryKeys as e } from "./adminAreaQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminAreaApi as n } from "@maat/api-main";
//#region src/areas/admin/useAdminAreasQuery.ts
var r = (r) => t({
	queryKey: e.list(r),
	queryFn: () => n.listAreas(r)
});
//#endregion
export { r as useAdminAreasQuery };
